/*** IMPORTS FROM imports-loader ***/
(function() {

require([
    'jquery',
    'pip-events',
    'pip-model',
    'pip-common.tooltips',
    'pip-common.utils',
    'pip-analytics',
    'pip-breadcrumbs',
    'pip-common.validate',
    'item_related_groups',
    'legacy_item_related_groups',
    'pip-sticky-nav',
    'pip-messaging_delivery',
    'pip-price',
    'pip-ecorebates',
    'pip-ssku',
    'pip-appliance_availability_check',
    'pip-appliance_delivery_options',
    'pip-recommendations',
    'pip-specifications',
    'pip-analytics__hddata',
    'pip-prop65-warning',
    'pip-rich-content',
    'pip-navigation',
    'pip-ratings-reviews',
    'pip-ratings-reviews-react',
    'pip-media-manager',
    'pip-media-gallery',
    'pip-media-expanded-view',
    'pip-sharebelt',
    'pip-myList',
    'pip-feature_based_recommendations',
    'thd-carousel',
    'pip-related_search_and_products',
    'cookie-utils',
    'commission-junction',
    'breakpoints',
    'pip-cards',
    'pip-domain',
    'auth.service',
    'verification.service',
    'pip-module-positioner',
    'pip-store_availability',
    'pip-bundling',
    'pip-chatbot-wrapper',
    'pip-default-badging',
    'pip-delivery-and-installation',
    'pip-expose-tnt-objects',
    'consumer-credit-message',
    'pip-analytics__consumer-credit-message',
    'pip-package_configurator',
    'custom-product-offering',
    'pip-package-bundling'
  ],
function (
    $,
    pipEvents,
    pip,
    pipTooltips,
    utils,
    pipAnalytics,
    pipBreadcrumbs,
    pipValidate,
    pipIRG,
    pipLegacyIRG,
    pipStickyNav,
    pipMessagingDelivery,
    pipPrice,
    pipEcorebates,
    pipSSKU,
    pipApplianceAvailabilityCheck,
    pipApplianceDeliveryOptions,
    pipRecommendations,
    pipSpecifications,
    analyticsHDdata,
    pipProp65Warning,
    pipRichContent,
    pipNavigation,
    pipRatingsReviews,
    pipRatingsReviewsReact,
    pipMediaManager,
    pipMediaGallery,
    pipMediaExpandedView,
    pipSharebelt,
    pipMyList,
    pipFeatureBasedRecommendations,
    thdCarousel,
    pipRelatedSearchAndProducts,
    cookieUtils,
    commissionJunction,
    breakpoints,
    pipCards,
    pipDomain,
    myAccountService,
    myVerificationService,
    pipModulePositioner,
    pipStoreAvailability,
    pipBundling,
    pipChatbotWrapper,
    pipDefaultBadging,
    pipDeliveryAndInstallation,
    pipExposeTntObjects,
    consumerCreditMessage,
    analyticsConsumerCreditMessage,
    pipPackageConfigurator,
    customProductOffering,
    packageBundling
){


    if (typeof DIGITAL_EMITTER !== 'undefined') {
        DIGITAL_EMITTER.trigger('jquery-ready');
    }

    var currentBreakpoint = breakpoints.getCurrentBreakpoint();

    // GLOBAL
    if(window.thdOnlineCommon){
        window.thdOnlineCommon.appAlias = "S6";
    }

    pipEvents.media.mediaLoaded.on('.mediaLoaded', function () {
      pipMediaGallery.init();
      pipBundling.init();
      if (pip.features.packageBundlingExperienceEnabled){
        packageBundling.init();
      }
      if (!pip.isB2BCustomer) {
        pipDeliveryAndInstallation.init();
      }
    });

    pipEvents.media.expandMediaView.on('.expandMediaView', function (evtType, data) {
        pipMediaExpandedView.build(data.target);
    });

    pipEvents.bazaarVoice.bazaarVoiceRatingsReviewLoaded.on('.bazaarVoiceRatingsReviewsLoaded', function () {
        pipStickyNav.updateRatingsReviews();
    });

    pipEvents.ssku.sskuChange.off('.sskuChange');
    pipEvents.ssku.sskuChange.on('.sskuChange', function(evtType, data) {
        initPip(data);
        pipNavigation.updateUrl();
        pipNavigation.updatePageTitle();
        THD && THD.DataCollection && THD.DataCollection.recordPageLoad();
        pipEvents.ssku.sskuInteraction.trigger(data);
    });

    pipEvents.ssku.sdskuChange.off('.sdskuChange');
    pipEvents.ssku.sdskuChange.on('.sdskuChange', function(evtType, data) {
        pip.update(data);
        pipSSKU.init(data.sdskuSelectedAttributes);
    });

    var initPipIRG = function() {
        var isApplianceInBundledCategory = utils.deepGet(pip, 'products.primary.data.info.applianceBundled');
        pipEvents.appliance.bundleRequestResolved.off('.bundleRequestResolved');
        if (isApplianceInBundledCategory) {
            pipEvents.appliance.bundleRequestResolved.on('.bundleRequestResolved', function(evtType, resolvedBoolean) {
                initDefaultOrApplianceIRG(resolvedBoolean);
            });
        } else {
            initDefaultOrApplianceIRG(false);
        }
    }

    var initDefaultOrApplianceIRG = function initDefaultOrApplianceIRG(isApplianceInBundledCategory) {
        if (pip.features.showDefaultIRGInApplianceEnabled){
            pipIRG.init(isApplianceInBundledCategory);
        } else {
            pipLegacyIRG.init(isApplianceInBundledCategory);
        }
    }

    $(function() {
        pipExposeTntObjects.init();
        cookieUtils.initializeCookieManager(pipDomain.getCookieDomain(), 'web');
        commissionJunction.updateCJInfo();
        myAccountService.init();
        myVerificationService.init();

        window.pipModelRequest.then(function(data) {
            initPip(data);
            pipValidate.init();
            pipAnalytics.init();
            pipBreadcrumbs.init();
            if (pip.features && pip.features.paymentEstimatorForApplianceEnabled && !pip.isB2BCustomer) {
                analyticsConsumerCreditMessage.init();
            }

            // PLEASE: don't put anything after this event
            var afterBundleEvent = document.createEvent('CustomEvent');
            afterBundleEvent.initCustomEvent('afterBundle', false, false, {});
            document.dispatchEvent(afterBundleEvent);
        });
    });

    function initPip(data){
        pip.update(data);
        pipRecommendations.init();
        pipModulePositioner.init();
        pipStickyNav.init();
        pipMediaManager.update();
        thdCarousel.init();
        pipRelatedSearchAndProducts.init();
        analyticsHDdata.init();

        initPipIRG();

        pipMessagingDelivery.init();
        pipPrice.init();
        pipEcorebates.init();
        pipSSKU.init();
        pipApplianceAvailabilityCheck.init();
        pipApplianceDeliveryOptions.init();
        pipSpecifications.init();
        pipProp65Warning.init();
        pipRichContent.init();
        pipNavigation.init();
        pipRatingsReviews.init();
        pipRatingsReviewsReact.init();
        pipSharebelt.init();
        pipCards.init();
        pipMyList.init();
        pipStoreAvailability.init();
        pipChatbotWrapper.init();
        if (pip.features && pip.features.paymentEstimatorForApplianceEnabled && !pip.isB2BCustomer) {
            consumerCreditMessage.init();
        }
        //--non-responsive
        //breakpoints.init();
        pipFeatureBasedRecommendations.init();
        pipPackageConfigurator.init();
        pipDefaultBadging.init();

      if(pip.features.customProductOfferingEnabled && pip.isB2BCustomer &&
        (pip.features.customProductOfferingEnabledInExperience.indexOf('ALL') !== -1 || pip.features.customProductOfferingEnabledInExperience.indexOf('APPLIANCE') !== -1)) {
        customProductOffering.init();
      }
    }
});

}.call(window));